import { Component } from '@angular/core';
import * as ChartConfig from './charts.config';
@Component({
  selector: 'app-client-custom-widget-layout',
  templateUrl: './custom-widget-layout.component.html',
  styleUrls: ['../../default/taiao-dashboard-layout/taiao-dashboard-layout.component.scss'],
})
export class ngatiawataikapiti_CustomWidgetLayoutComponent {
  ChartConfig = ChartConfig;
}
